import { render } from "./BGBasicAlerts.vue?vue&type=template&id=0814640a&ts=true"
import script from "./BGBasicAlerts.vue?vue&type=script&lang=ts"
export * from "./BGBasicAlerts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__